import { useIntl } from 'react-intl';
import { MenuItemDishCategory } from '~/libs/gql/types';

const categories = new Set<string>(Object.values(MenuItemDishCategory));

// Category URLs use hyphens, e.g. /categories/tacos-burritos
export const dishCategorySlug = (category: MenuItemDishCategory) => category.replace(/_/g, '-');

export const dishCategoryFromSlug = (slug: string) => {
  if (slug.includes('_')) return null;

  const category = slug.replace(/-/g, '_');
  return categories.has(category) ? category as MenuItemDishCategory : null;
};

export const useDishCategoryName = () => {
  const intl = useIntl();
  const names: Record<MenuItemDishCategory, string> = {
    [MenuItemDishCategory.AppetizersSmallPlates]: intl.formatMessage({ defaultMessage: 'Appetizers & Small Plates' }),
    [MenuItemDishCategory.Bakery]: intl.formatMessage({ defaultMessage: 'Bakery' }),
    [MenuItemDishCategory.Barbecue]: intl.formatMessage({ defaultMessage: 'Barbecue' }),
    [MenuItemDishCategory.Bowls]: intl.formatMessage({ defaultMessage: 'Bowls' }),
    [MenuItemDishCategory.BreakfastBrunch]: intl.formatMessage({ defaultMessage: 'Breakfast & Brunch' }),
    [MenuItemDishCategory.Burgers]: intl.formatMessage({ defaultMessage: 'Burgers' }),
    [MenuItemDishCategory.Chicken]: intl.formatMessage({ defaultMessage: 'Chicken' }),
    [MenuItemDishCategory.Curries]: intl.formatMessage({ defaultMessage: 'Curries' }),
    [MenuItemDishCategory.Desserts]: intl.formatMessage({ defaultMessage: 'Desserts' }),
    [MenuItemDishCategory.Drinks]: intl.formatMessage({ defaultMessage: 'Drinks' }),
    [MenuItemDishCategory.Dumplings]: intl.formatMessage({ defaultMessage: 'Dumplings' }),
    [MenuItemDishCategory.HotDogs]: intl.formatMessage({ defaultMessage: 'Hot Dogs' }),
    [MenuItemDishCategory.Noodles]: intl.formatMessage({ defaultMessage: 'Noodles' }),
    [MenuItemDishCategory.Pasta]: intl.formatMessage({ defaultMessage: 'Pasta' }),
    [MenuItemDishCategory.Pizza]: intl.formatMessage({ defaultMessage: 'Pizza' }),
    [MenuItemDishCategory.RiceDishes]: intl.formatMessage({ defaultMessage: 'Rice Dishes' }),
    [MenuItemDishCategory.Salads]: intl.formatMessage({ defaultMessage: 'Salads' }),
    [MenuItemDishCategory.Sandwiches]: intl.formatMessage({ defaultMessage: 'Sandwiches' }),
    [MenuItemDishCategory.Seafood]: intl.formatMessage({ defaultMessage: 'Seafood' }),
    [MenuItemDishCategory.Sides]: intl.formatMessage({ defaultMessage: 'Sides' }),
    [MenuItemDishCategory.SoupsStews]: intl.formatMessage({ defaultMessage: 'Soups & Stews' }),
    [MenuItemDishCategory.SteakChops]: intl.formatMessage({ defaultMessage: 'Steak & Chops' }),
    [MenuItemDishCategory.Sushi]: intl.formatMessage({ defaultMessage: 'Sushi' }),
    [MenuItemDishCategory.TacosBurritos]: intl.formatMessage({ defaultMessage: 'Tacos & Burritos' }),
    [MenuItemDishCategory.VegetarianMains]: intl.formatMessage({ defaultMessage: 'Vegetarian Mains' }),
    [MenuItemDishCategory.Wings]: intl.formatMessage({ defaultMessage: 'Wings' }),
  };

  return (category: MenuItemDishCategory) => names[category];
};
